
















import { BusinessHoursInterface, DEFAULT_BUSINESS_HOURS } from '@/pages/TWMAfterHoursSettings/types/business-hours'
import { Component, Vue } from 'vue-property-decorator'
import TechTaskCard, { DefaultServerResponse } from '@/components/ui/TechTaskCard.vue'
import AccountIdInput from '@/components/ui/AccountIdInput.vue'
import BusinessHours from '@/pages/TWMAfterHoursSettings/BusinessHours.vue'
import request from '@/helpers/requests'


interface LoadRequestPayload {
    pulsemAccountId: number|null;
}

interface RequestPayload {
    pulsemAccountId: number|null;
    businessHours: BusinessHoursInterface;
    enable: 0|1|null;
    text: string|null;
}

interface ResponsePayload extends DefaultServerResponse {
    data: RequestPayload;
}


@Component({
    components: {
        AccountIdInput,
        TechTaskCard,
        BusinessHours
    }
})
export default class TWMAfterHoursSettings extends Vue {
    locationValid = false
    pulsemAccountId: number|null = null
    businessHours: BusinessHoursInterface = DEFAULT_BUSINESS_HOURS
    enable: 0|1|null = null
    text: string|null = null

    get requestPayload(): RequestPayload {
        return {
            pulsemAccountId: this.pulsemAccountId,
            businessHours: this.businessHours,
            enable: this.enable,
            text: this.text
        }
    }

    get loadRequestPayload(): LoadRequestPayload {
        return {
            pulsemAccountId: this.pulsemAccountId
        }
    }

    async loadSettings(): Promise<ResponsePayload> {
        return await request.post('/support/twm-after-hours-settings-load', this.loadRequestPayload) as ResponsePayload
    }

    async onLocationChange(locationValid: boolean) {
        if (locationValid) {
            const response = await this.loadSettings()
            this.businessHours = response.data.businessHours
            this.enable = response.data.enable
            this.text = response.data.text
        } else {
            this.businessHours = DEFAULT_BUSINESS_HOURS
            this.enable = null
            this.text = null
        }
        this.locationValid = locationValid
    }

    onSuccess(status: boolean) {
        if (status) {
            this.locationValid = false
            this.pulsemAccountId = null
            this.businessHours = DEFAULT_BUSINESS_HOURS
            this.enable = null
            this.text = null
        }
    }
}
